// Notes
// `/g` has been removed from end of this RegExp, because when it's used as JavaScript variable, it then causes WRONG comparison inside of regExp.test() logic.
// As of July 2026 the longest known TLD is 14 characters, so we limit by 15 so that not to allow very HUGE value.
export const EMAIL_REGEXP =
  /^[\w.+-]+@((?!-)[a-z\d-]+(?<!-)\.)+(?!\d)[a-z\d]{2,15}$/i;
// RFC 5322 Compliance: The official email standard allows more complex formats, including quoted strings and IP addresses in the domain.
// Fully RFC-compliant regexes exist but are extremely long and inefficient for practical use
// https://datatracker.ietf.org/doc/html/rfc5322
// https://pdw.ex-parrot.com/Mail-RFC822-Address.html
